import { useUser } from '@clerk/clerk-react';
import { useState, useEffect } from 'react';

export function useRole() {
  const { user } = useUser();
  const [role, setRole] = useState<string>('user');

  useEffect(() => {
    if (user) {
      // Get role from user metadata or default to 'user'
      const userRole = user.publicMetadata?.role as string || 'user';
      setRole(userRole);
    }
  }, [user]);

  return { role };
} 